import { Grid, GridProps } from '@mui/material';

interface Props extends React.PropsWithChildren, GridProps {
  onClick?: () => void;
}

const Row: React.FC<Props> = (props) => {
  const { children, style, sx, className, ...rest } = props;

  return (
    <Grid
      {...rest}
      className={className ? className : 'row'}
      style={{ display: 'flex', flexDirection: 'row', ...style }}
      sx={sx}>
      {children}
    </Grid>
  );
};
export default Row;
